"use client";

import Image from "next/image";
import { useReducedMotion } from "motion/react";
import { useLingui } from "@lingui/react/macro";
import { Dialog, MediaPlayer } from "@marketing-sites/ui/primitives";
import { VIDEO_ID, VIDEO_URL, LOOP_MP4, LOOP_POSTER } from "../_lib/media";

export function HeroVideo() {
  const { t } = useLingui();
  const reducedMotion = useReducedMotion();

  return (
    <Dialog.Root
      openMetadata={{ analyticsId: "modal_intercom_link_hero_video_opened" }}
      closeMetadata={{ analyticsId: "modal_intercom_link_hero_video_closed" }}
    >
      <Dialog.Trigger
        aria-label={t`Watch the Intercom product demo`}
        className="group relative aspect-video w-full cursor-pointer overflow-hidden rounded-lg bg-white"
      >
        {reducedMotion ? (
          <Image
            src={LOOP_POSTER}
            alt=""
            fill
            sizes="(max-width: 1024px) 100vw, 540px"
            className="object-cover"
          />
        ) : (
          <video
            src={LOOP_MP4}
            poster={LOOP_POSTER}
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-hidden
            tabIndex={-1}
            className="absolute inset-0 size-full object-cover"
          />
        )}
        <span className="bg-black/8 group-hover:bg-black/16 absolute inset-0 flex items-center justify-center transition-colors">
          <span className="bg-off-black flex size-14 items-center justify-center rounded-full text-white shadow-lg ring-1 ring-white/25 transition-transform group-hover:scale-110">
            <MediaPlayer.PlayIcon className="w-5" />
          </span>
        </span>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Viewport>
          <Dialog.Popup
            aria-label={t`Intercom product demo`}
            className="bg-off-black w-[min(64rem,calc(100vw-2rem))]"
            closeButton={
              <Dialog.Close
                aria-label={t`Close`}
                className="text-button-sm absolute right-4 top-4 z-10 cursor-pointer text-white underline"
              >
                {t`Close`}
              </Dialog.Close>
            }
          >
            <div className="relative aspect-video w-full">
              <MediaPlayer.Context
                video={{
                  url: VIDEO_URL,
                  id: VIDEO_ID,
                  poster: LOOP_POSTER,
                  title: t`Intercom product demo`,
                }}
              >
                <MediaPlayer.Root>
                  <MediaPlayer.Video
                    autoplay
                    playsInline
                    analyticsId="evt_intercom_link_demo_video"
                  />
                  <MediaPlayer.Overlay playLabel={t`Play`} />
                  <MediaPlayer.Controls />
                  <MediaPlayer.SettingsMenu />
                </MediaPlayer.Root>
              </MediaPlayer.Context>
            </div>
          </Dialog.Popup>
        </Dialog.Viewport>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
